import { getPOIFrom } from '../../utils';
import eventBus from '../../utils/emitter-event-bus';
import { NavigatorEventBus, POI_ID } from '../navigator/navigator.model';
import { WorldEventBus } from '../world/world.model';
import { POISpotlight } from './spotlight.model';

export class Spotlight {
  private static instance: Spotlight;

  constructor() {
    eventBus.on(WorldEventBus.initialise, (poi) => this.updateSpotlight(poi));
    eventBus.on(NavigatorEventBus.navigationStart, (poi) => this.updateSpotlight(poi));
  }

  public static getInstance(): Spotlight {
    if (!Spotlight.instance) {
      Spotlight.instance = new Spotlight();
    }
    return Spotlight.instance;
  }

  private updateSpotlight(poi: POI_ID) {
    const spotlight = this.fetchSpotlight(poi);
    if (!spotlight) {
      this.clearSpotlight();
      return;
    }
    this.renderTitle(spotlight.title);
    this.renderDescription(spotlight.description);
  }

  private clearSpotlight() {
    this.renderTitle('');
    this.renderDescription('');
  }

  private renderTitle(title: string): void {
    const titleElement = <HTMLElement>document.querySelector('.js-spotlight-title');
    titleElement.innerText = title;
  }

  private renderDescription(description: string | undefined): void {
    const descriptionElement = <HTMLElement>document.querySelector('.js-spotlight-description');
    descriptionElement.innerText = description || '';
  }

  private fetchSpotlight(poi: POI_ID): POISpotlight | undefined {
    return getPOIFrom(poi)?.spotlight;
  }
}
